import { useState, useEffect } from 'react';

import { getCalendars } from '../api';
import CalendarItemsTable from '../components/calendars/CalendarItemsTable';
import Loader from '../components/loader/Loader';
import { sortDataWithDirection } from 'common/utils';

const Calendar = () => {
  const [calendars, setCalendars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCalendars = async () => {
      try {
        setLoading(true);
        const data = await getCalendars();
        setCalendars(sortDataWithDirection(data || [], 'createdAt', 'desc'));
      } catch (error) {
        console.error('Failed to fetch calendars:', error);
        setCalendars([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCalendars();
  }, []);

  return (
    <div className="w-full space-y-6">
      <div className="flex justify-between space-x-3">
        <h1 className="text-h3">Content Calendar</h1>
      </div>

      {loading && (
        <div className="relative">
          <Loader />
        </div>
      )}

      {!loading && calendars.length === 0 && (
        <div className="flex items-center justify-center py-12">
          <p>No calendar found - check back soon!</p>
        </div>
      )}

      {!loading && (
        <div className="divide-y divide-gray-100">
          {calendars.map((calendar) => (
            <div key={calendar.calendarId} className="py-8 first:pt-0">
              <CalendarItemsTable calendar={calendar} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Calendar;
